/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { MdCheckCircle, MdCancel } from "react-icons/md";
import { format } from "date-fns";
import Card from "components/card";
import Loader from "components/loader/Loader";
import { useGlobalContext } from "context/globalContext";
import EditOrDeleteOnboard from "../edit-del-template/editAndDeleteonBoard";
import CreateOnboard from "../create-template/createOnboard";
import {
  getOnboardTemplatesAPI,
  getFilterOnboardTemplateAPI,
} from "Api/onBoardAPI";

const OnBoardTable = () => {
  const { fetchMessage, setFetchMessage } = useGlobalContext();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const debounceRef = useRef();
  const token = localStorage.getItem("jwtToken");
  const pageSize = 10;

  console.log(setFilterType);
  const handleSearchQuery = useCallback((value) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSearchQuery(value);
      setPageIndex(0);
    }, 300);
  }, []);

  const fetchTemplates = useCallback(async () => {
    setIsLoading(true);
    try {
      let response;
      if (searchQuery || filterType) {
        response = await getFilterOnboardTemplateAPI(
          { searchQuery, templateType: filterType, pageIndex, limit: pageSize },
          setIsLoading,
          token
        );
        if (response) {
          setTableData(Array.isArray(response.data) ? response.data : []);
          setTotalPages(response.totalPages || 1);
        }
      } else {
        response = await getOnboardTemplatesAPI(
          { pageIndex, skip: pageSize },
          setIsLoading,
          token
        );
        if (response) {
          setTableData(Array.isArray(response.data) ? response.data : []);
          setTotalPages(1);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setFetchMessage(false);
    }
  }, [searchQuery, pageIndex, filterType, token, setFetchMessage]);

  useEffect(() => {
    if (fetchMessage || searchQuery !== undefined || pageIndex !== undefined) {
      fetchTemplates();
    }
  }, [fetchMessage, searchQuery, pageIndex, fetchTemplates]);

  const columns = useMemo(
    () => [
      {
        Header: "Type",
        accessor: "type",
        id: "type",
      },
      {
        Header: "Title",
        accessor: (row) =>
          row.type === "signUp" ? row.signUp?.title : row.welcome?.title || "-",
        id: "title",
      },
      {
        Header: "Subtitle",
        accessor: (row) =>
          row.type === "signUp"
            ? row.signUp?.subTitle
            : row.welcome?.subTitle || "-",
        id: "subtitle",
      },
      {
        Header: "Button Name",
        accessor: (row) => row?.welcome?.buttonName ?? "-",
        id: "buttonName",
      },
      {
        Header: "Login Link",
        accessor: (row) => row?.welcome?.loginLink ?? "-",
        id: "loginLink",
      },

      {
        Header: "Show Login Button",
        accessor: (row) =>
          row.signUp?.showLoginButton ?? row.welcome?.showLoginButton ?? false,
        id: "showLoginButton",
        Cell: ({ value }) => (value ? "Yes" : "No"),
      },
      {
        Header: "Booking",
        accessor: (row) =>
          row.type === "signUp" ? row.signUp?.booking || "-" : "-",
        id: "booking",
      },

      {
        Header: "Show Down Arrow",
        id: "showDownArrow",
        accessor: (row) =>
          row.type === "signUp" ? row.signUp?.showDownArrow : null,
        Cell: ({ row }) =>
          row.original.type === "signUp"
            ? row.original.signUp?.showDownArrow
              ? "Yes"
              : "No"
            : "-",
      },

      { Header: "   Tid", accessor: "paramValue", id: "paramValue" },
      {
        Header: "Status",
        accessor: "status",
        id: "status",
        Cell: ({ value }) =>
          value === "active" ? (
            <MdCheckCircle className="text-xl text-green-500" />
          ) : (
            <MdCancel className="text-xl text-red-500" />
          ),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        id: "createdAt",
        Cell: ({ value }) =>
          value ? format(new Date(value), "yyyy-MM-dd HH:mm:ss") : "-",
      },
      {
        Header: "Actions",
        accessor: "id",
        id: "actions",
        Cell: ({ row }) => (
          <EditOrDeleteOnboard
            rowData={row.original}
            refreshTable={fetchTemplates}
          />
        ),
      },
    ],
    [fetchTemplates]
  );

  const tableInstance = useTable(
    {
      columns,
      data: tableData,
      manualPagination: true,
      pageCount: totalPages,
      initialState: { pageIndex, pageSize },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;

  const handlePageChange = (direction) => {
    if (direction === "next" && pageIndex < totalPages - 1)
      setPageIndex((prev) => prev + 1);
    if (direction === "previous" && pageIndex > 0)
      setPageIndex((prev) => prev - 1);
  };

  return (
    <Card extra="w-full h-full p-4">
      <div className="mb-4 flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          OnBoard Templates
        </div>

        <div className="flex items-center gap-4">
          {/* <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="w-40 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-gray-800 dark:text-white"
          >
            <option value="signUp">Sign Up</option>
            <option value="welcome">Welcome</option>
          </select> */}

          <CreateOnboard
            selectedType={filterType}
            refreshTable={fetchTemplates}
          />
        </div>
      </div>

      <div className="relative mb-4 w-full sm:w-64">
        <input
          type="search"
          className="w-full rounded-md border border-gray-300 py-2 px-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-gray-800 dark:text-white"
          placeholder="Search"
          onChange={(e) => handleSearchQuery(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto">
        {isLoading ? (
          <div className="flex h-[400px] w-full items-center justify-center">
            <Loader />
          </div>
        ) : tableData.length === 0 ? (
          <span className="block w-full text-center">No data found.</span>
        ) : (
          <table {...getTableProps()} className="w-full">
            <thead>
              {headerGroups.map((headerGroup, i) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                  {headerGroup.headers.map((column, idx) => (
                    <th
                      key={idx}
                      className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700"
                    >
                      <p className="w-20 text-xs tracking-wide text-gray-600">
                        {column.render("Header")}
                      </p>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={i}>
                    {row.cells.map((cell, idx) => (
                      <td
                        {...cell.getCellProps()}
                        key={idx}
                        className="px-2 py-2 text-sm sm:text-base"
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {tableData.length > 0 && (
        <div className="mt-4 flex items-center justify-between">
          <button
            onClick={() => handlePageChange("previous")}
            disabled={pageIndex === 0}
            className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
              pageIndex > 0
                ? "bg-blue-500 hover:bg-blue-600"
                : "cursor-not-allowed bg-gray-300"
            }`}
          >
            Previous
          </button>

          <span className="text-sm text-gray-700 dark:text-white">
            Page <strong>{pageIndex + 1}</strong> of{" "}
            <strong>{totalPages}</strong>
          </span>

          <button
            onClick={() => handlePageChange("next")}
            disabled={pageIndex >= totalPages - 1}
            className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
              pageIndex < totalPages - 1
                ? "bg-blue-500 hover:bg-blue-600"
                : "cursor-not-allowed bg-gray-300"
            }`}
          >
            Next
          </button>
        </div>
      )}
    </Card>
  );
};

export default OnBoardTable;
